<template>
  <div v-bind:class="{ 'detail': !isMobile && !minial, 'o-form__sp-bottom__detail': isMobile }">
      <input-label :for="id" :label="label" :required="required" v-bind:class="{ 'detail__title': !minial, 'sub-title': minial }"/>
      <text-input
        v-model="model"
        :id="id"
        ref="input"
        v-bind="$attrs"
        :type="type"
        :error="error"
        :error-class="errorClass"
        :required="required"
        :resetInput="resetInput"
        @focus="$emit('focus', false)"
      ></text-input>
      <error-message v-if="error" :message="error"></error-message>
      <help-text v-if="helpText" :text="helpText"></help-text>
  </div>
</template>

<script>
import TextInput from '@/shared/Input/TextInput'
import InputLabel from '@/shared/Input/InputLabel'
import ErrorMessage from '@/shared/Input/ErrorMessage'
import HelpText from '@/shared/Input/HelpText'

export default {
  components: {
    TextInput,
    InputLabel,
    ErrorMessage,
    HelpText,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String | Number,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: String,
    error: String,
    errorClass: {
      type: String,
      default: 'border-red-400',
    },
    minial: {
      type: Boolean | null,
      default: false,
      required: false,
    },
    helpText: String,
    isMobile: {
      type: Boolean,
      default: false,
      required: false,
    },
    resetInput: Boolean
  },
  data() {
    return {
      model: this.value,
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
  },
}
</script>
